export const TRACKING_SALE_URL = (saleId: string) => `/sales/tracking/${saleId}?packageType=ecommerce&origin=tracking`

export const SALE_PRODUCTS_URL = (packageId: string) => `/packages/tracking/sales/${packageId}/products`

export const WAREHOUSE_EXPANDED_DATA_URL = (warehouseId: string) => `/warehouses/tracking/${warehouseId}`

export const COMPANY_PERSONALIZATION_URL = '/company/personalization'

export const DOWNLOAD_DELIVERY_CODE_URL = '/sales/tracking/qr-code/download'

export const SEND_TRACKING_NUMBER_URL = '/packages/tracking/sale/mail'

export const VERIFY_MAIL_URL = '/auth/validate-email'

export const TRACKING_DELIVERY_MAP_URL = '/map-data/tracking/delivery-map'

export const COURIER_EVENTS_URL = (pinflagId: string, companyId: string) => `/packages/tracking/${pinflagId}/courier/logs/${companyId}`

export const REPORT_DELIVERY_ISSUE_URL = '/companies/package/report-delivery-issue'
